import React from "react";
import { Footer } from "./style";

const FooterElement = () => {
  return <Footer>{new Date().getFullYear()} | Rodrigo Antunes</Footer>;
};

export default FooterElement;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js